"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Device = void 0;
class Device {
    constructor(breakpoints) {
        this.breakPoints = breakpoints;
        this.recognize();
        window.addEventListener('resize', () => {
            this.recognize();
        });
        this.orientationChangeAddListener(() => {
            this.recognize();
        });
    }
    recognize() {
        if (window.innerWidth >= this.breakPoints.xl) {
            this.shorthand = 'xl';
        }
        else if (window.innerWidth >= this.breakPoints.lg) {
            this.shorthand = 'lg';
        }
        else if (window.innerWidth >= this.breakPoints.md) {
            this.shorthand = 'md';
        }
        else if (window.innerWidth >= this.breakPoints.sm) {
            this.shorthand = 'sm';
        }
        else {
            this.shorthand = 'xs';
        }
    }
    fullName() {
        switch (this.shorthand) {
            case 'xl':
            case 'lg':
            case 'md':
                return 'Desktop';
            case 'sm':
                return 'Tablet';
            case 'xs':
                return 'Mobile';
            default:
                return 'Desktop';
        }
    }
    orientationFullName() {
        if (window.matchMedia) {
            const landscapeMatch = window.matchMedia('(orientation: landscape)');
            if (landscapeMatch.matches) {
                return 'Landscape';
            }
            const portraitMatch = window.matchMedia('(orientation: portrait)');
            if (portraitMatch.matches) {
                return 'Portrait';
            }
        }
        return 'Landscape';
    }
    orientationChangeAddListener(callback) {
        if (window.matchMedia) {
            const portraitMatch = window.matchMedia('(orientation: portrait)');
            portraitMatch.addListener(() => callback());
        }
    }
    get deviceSystem() {
        return {
            Android: function () {
                if (navigator.userAgent.match(/Android/i))
                    return true;
                else
                    return false;
            },
            BlackBerry: function () {
                if (navigator.userAgent.match(/BlackBerry/i))
                    return true;
                else
                    return false;
            },
            iOS: function () {
                if (navigator.userAgent.match(/iPhone|iPad|iPod/i))
                    return true;
                else
                    return false;
            },
            Opera: function () {
                if (navigator.userAgent.match(/Opera Mini/i))
                    return true;
                else
                    return false;
            },
            Windows: function () {
                if (navigator.userAgent.match(/IEMobile/i))
                    return true;
                else
                    return false;
            }
        };
    }
}
exports.Device = Device;
